module.exports = __webpack_public_path__ + "static/img/engb2.89e47a5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/eng/engb2.png
// module id = 8hoJ
// module chunks = 0